import { Request } from "@xt/xtbase";
const { XtAxios } = Request;

const URL = "/";

//U本位市场列表
export function get_fapiSymbolList(config?) {
  return XtAxios.get(URL + `fapi/market/v1/public/symbol/list`, config);
}